import { useTranslation } from 'react-i18next'

import {
  last30Days,
  lastMonth,
  lastYear,
  oneWeek,
  thisMonth,
} from '@pages/IntroducingBroker/Dashboard/constants/performance'

import { RangeOption } from '@ui/v2/Calendar/RangeOptions'

export const useCalendarRangeOptions = (): RangeOption[] => {
  const { t } = useTranslation()

  return [
    {
      label: t('Calendar.Week'),
      id: 'week',
      value: oneWeek,
    },
    {
      label: t('Calendar.Last 30 Days'),
      id: 'last-30-days',
      value: last30Days,
    },
    {
      label: t('Calendar.This Month'),
      id: 'this-month',
      value: thisMonth,
    },
    {
      label: t('Calendar.Last Month'),
      id: 'last-month',
      value: lastMonth,
    },
    {
      label: t('Calendar.Last Year'),
      id: 'last-year',
      value: lastYear,
    },
  ]
}
